import { render, staticRenderFns } from "./purchase-table.vue?vue&type=template&id=46d210de&scoped=true&"
import script from "./purchase-table.vue?vue&type=script&lang=js&"
export * from "./purchase-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d210de",
  null
  
)

export default component.exports